import imagesLoaded from "imagesloaded";
import Isotope from "isotope-layout";

export const isotopeEnhancer = function (el) {
    const iso = new Isotope(el, {
        itemSelector: ".masonry__item",
        percentPosition: true,
        masonry: {
            columnWidth: ".masonry__grid-sizer",
            gutter: ".masonry__gutter-sizer",
        },
    });
    imagesLoaded(el).on("progress", function () {
        iso.layout();
    });
};
